<template>
    <div v-if="departmentId != null" class="room-size-slider">
        <label id="sliderLabel" class="room-size-slider__label" v-html="(size > -1 ? showValue :
            dictionary.PriceFinderSliderEmptyValue)"></label>
        <Slider v-model="size" :min="minimumSize" :max="maximumSize" aria-labelledby="sliderLabel"
            v-on:slideend="handleSlideChange" />
        <p class="room-size-slider__close-result" v-if="showCloseResult">{{ dictionary.PriceFinderRoomCloseResultText }}
        </p>
    </div>
</template>
<script>
import Slider from 'primevue/slider';
const serviceUrl = "/umbraco/api/departmentsapi/";
export default {
    name: "roomSizeSlider",
    components: {
        Slider
    },
    props: ["departmentId", "initialSize", "minimum", "maximum", "unit"],
    data() {
        return {
            dictionary: [],
            size: -1,
            currentSize: 0,
            showCloseResult: false,
            minimumSize: 0,
            maximumSize: 10,
            showValue: ""
        };
    },
    created() {
        const vm = this;
        fetch("/umbraco/api/dictionaryapi/GetRoomSizeSliderDictionary").then((response) => response.json())
            .then((data) => {
                vm.dictionary = data;
                if (vm.minimum) {
                    vm.minimumSize = Math.floor(vm.minimum);
                }
                if (vm.maximum) {
                    vm.maximumSize = Math.ceil(vm.maximum)
                }
                if (vm.initialSize) {
                    vm.size = parseInt(vm.initialSize);
                    vm.handleSlideChange();
                }
            })
            .catch((error) => {
                console.log(error);
            });


    },
    methods: {
        handleSlideChange() {
            const vm = this;
            $.get(serviceUrl + 'GetRoomsBySize',
                {
                    departmentId: vm.departmentId,
                    size: vm.size,
                    getCloseIfNone: true,
                    availability:true,
                },
                function (response) {
                    vm.currentSize = vm.size;
                    vm.showCloseResult = response.Rooms != null && !response.Rooms.some(x => Math.floor(parseFloat(x[0].Size)) == vm.currentSize);

                    vm.$emit('sliderChanged', response.Rooms);
                }).fail(function (error) {
                    vm.$emit('sliderChanged', null);
                }).always(function () {
                });
        },
        updateShowValue() {
            const vm = this;
            switch (vm.unit) {
                case "volume":
                    vm.showValue = `${(vm.size * 2.7).toFixed(1)} m<sup>3</sup>`;
                    break;
                case "area":
                default:
                    vm.showValue = `${vm.size} m<sup>2</sup>`;
                    break;
            }
        }
    },
    watch: {
        size(newSize, oldSize) {
            this.updateShowValue();
        },
        unit(newUnit, oldUnit) {
            this.updateShowValue();
        },
        departmentId(newId, oldId) {
            if (newId != oldId) {
                this.handleSlideChange();
            }
        }
    }
};
</script>
